import { ROLES } from 'config';

const adminCompanyConfig = ($stateProvider) => {

  'ngInject';

  $stateProvider
    .state('admin_company', {
      url: '/admin/companies/:id',
      template: '<app-admin-company></app-admin-company>',
      access: {
        loginRequired: true,
        roles: [ROLES.ADMIN],
      },
      params : {
        name : null, // hides name param
      },
    });
};

export default adminCompanyConfig;



// WEBPACK FOOTER //
// ./src/modules/admin-company-detail/config.js